"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _utils = require("../../../../../../../../common/utils");

require("./styles/_featured-list-item.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function handleFavourite(onToggleFavourite) {
  return function (e) {
    if (!onToggleFavourite) {
      return;
    }

    e.stopPropagation();
    onToggleFavourite();
  };
}

function FeaturedListItem(props) {
  var post = props.post,
      onViewPost = props.onViewPost,
      onToggleFavourite = props.onToggleFavourite,
      openReportModal = props.openReportModal;
  var assetId = post.assetId,
      thumbnailUrl = post.thumbnailUrl,
      title = post.title,
      createdByUser = post.createdByUser,
      isFavourited = post.isFavourited;
  var creatorName = "".concat(createdByUser.firstName, " ").concat(createdByUser.lastName);
  return _react.default.createElement(_uiKit.List.CardItem, {
    className: "featured-list-item",
    onClick: onViewPost
  }, _react.default.createElement("div", {
    className: "featured-list-item__preview"
  }, _react.default.createElement(_commonReact.AssetPreview, _extends({}, (0, _utils.buildAssetPreviewProps)({
    assetId: assetId,
    thumbnailUrl: thumbnailUrl
  }), {
    height: "100%",
    hideFileTypeIcon: true
  })), _react.default.createElement(_uiKit.Icon, {
    className: "featured-list-item__favourite",
    name: "".concat(isFavourited ? 'favfull' : 'favempty'),
    hoverColor: "".concat(isFavourited ? 'russian' : 'redApple'),
    size: 25,
    color: "white",
    onClick: handleFavourite(onToggleFavourite)
  })), _react.default.createElement("div", {
    className: "featured-list-item__info"
  }, _react.default.createElement("div", {
    className: "featured-list-item__info__text"
  }, _react.default.createElement(_uiKit.Text, {
    darkTheme: true,
    heading4: true,
    ellipsisOverflow: true,
    className: "featured-list-item__info__title"
  }, title), _react.default.createElement("div", {
    className: "featured-list-item__info__footer"
  }, _react.default.createElement("div", {
    className: "featured-list-item__info__footer__user"
  }, _react.default.createElement(_uiKit.Image, {
    sourceUrl: createdByUser.imageUrl,
    circular: true,
    height: "20px",
    width: "20px",
    placeholderText: creatorName,
    placeholderTextSize: 8
  }), _react.default.createElement(_uiKit.Text, {
    darkTheme: true
  }, creatorName)))), _react.default.createElement("div", {
    className: "featured-list-item__action"
  }, _react.default.createElement(_uiKit.ActionPopup, {
    options: [{
      label: 'Report',
      action: openReportModal,
      isRed: true
    }]
  }))));
}

var _default = FeaturedListItem;
exports.default = _default;